import { disclosuresDev } from '../../../constants/disclosures/disclosures-dev'
import { disclosuresProd } from '../../../constants/disclosures/disclosures-prod'
import { type DisclosureEnv } from '../../../types/disclosure-env'

export const geBrokerageCompanionInvestmentDisclosures = (env: DisclosureEnv) => {
  const _disclosures = env === 'dev' ? disclosuresDev : disclosuresProd

  // Variables used in the final disclosure object
  const dwAccountAgreementsHelper = 'Customer Agreement, Terms of Use, and Privacy Policy for Companion Account'

  // All account type overrides here
  const dwAccountAgreementsCustomerAgreementText = 'Customer Agreement'
  const dwAccountAgreementsLinks = [
    {
      text: dwAccountAgreementsCustomerAgreementText,
      url: 'https://legal.drivewealth.com/customer-account-agreement',
      effectiveDate: '2023-03-31',
    },
    {
      text: 'Terms of Use',
      url: 'https://legal.drivewealth.com/terms-of-use',
    },
    {
      text: 'Privacy Policy',
      url: 'https://legal.drivewealth.com/privacy-policy',
      effectiveDate: '2021-02-01',
    },
    {
      text: 'Limited Purpose Margin Account Agreement',
      url: 'https://legal.drivewealth.com/margin-risk-disclosure-statement',
      effectiveDate: '2025-01-06',
    },
  ]

  return {
    dw_account_agreements: {
      title: 'DriveWealth Account Agreements',
      helper: dwAccountAgreementsHelper,
      expanded: '',
      links: dwAccountAgreementsLinks,
    },
    dw_portfolio_management_agreements: {
      title: 'DriveWealth Portfolio Management Agreements',
      helper: 'Trading, Cash Management, and Market Data Agreements',
      expanded: '',
      links: [
        {
          text: 'Trading Disclosures',
          url: 'https://legal.drivewealth.com/fractional-shares-disclosure',
          effectiveDate: '2024-10-29',
        },
        {
          text: 'Cash Management Disclosure',
          url: 'https://legal.drivewealth.com/cash-management-program-disclosure-statement',
          effectiveDate: '2024-03-26',
        },
        {
          text: 'BATS Market Data Agreement',
          url: 'https://legal.drivewealth.com/bats-subscriber-agreement?lang=en_US',
        },
        {
          text: 'NASDAQ Subscriber Agreement',
          url: 'https://legal.drivewealth.com/nasdaq-subscriber-agreement?lang=en_US',
        },
        {
          text: 'NYSE/AMEX Subscriber Agreement',
          url: 'https://legal.drivewealth.com/nyse-amex-subscriber-agreement?lang=en_US',
          effectiveDate: '2023-10-03',
        },
      ],
    },
    dw_rule14b_1c: {
      title: 'Rule 14b-1(c)',
      helper: 'Rule of the Securities Exchange Act ',
      expanded:
        "Rule of the Securities Exchange Act Rule 14b-1(c) of the Securities Exchange Act, unless you object, requires us to disclose to an issuer, upon its request, the names, addresses, and securities positions of our customers who are beneficial owners of the issuer's securities held by us in nominee name. The issuer would be permitted to use your name and other related information for corporation communication only.",
      links: [],
    },
    eg_wealth_advisors: {
      title: 'Evergreen Wealth Advisors Disclosures',
      helper: 'ADV Part 2A & 2B, Customer Relationship Summary',
      expanded: '',
      links: [
        {
          text: 'ADV Part 2A & 2B',
          url: _disclosures.advWrapFeeDisclosure,
        },
        {
          text: 'Customer Relationship Summary',
          url: _disclosures.customerRelationshipSummaryDisclosure,
        },
      ],
    },
  }
}
